/* Change this file to get your personal Portfolio */
// To change portfolio colors globally go to the _globalColor.scss file
import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen
const splashScreen = {
  enabled: true, 
  animation: splashAnimation,
  duration: 2000 
};

// Summary And Greeting Section
const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Ahmed Ayman",
  title: "Hi all, I'm Ahmed Ayman",
  subTitle: emoji(
    "Full-Stack Software Engineer skilled in designing and developing scalable web applications using Spring Boot and React. Experienced in building robust RESTful APIs, implementing clean architecture, and delivering responsive user interfaces with strong attention to code quality, performance, and maintainability."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1g-wbUw3zcXfwyiLy5wPOjMBraG8X0Xxz/view?usp=sharing", 
  displayGreeting: true 
};

// Social Media Links
const socialMediaLinks = {
  github: "https://github.com/ahmadayman28",
  linkedin: "https://www.linkedin.com/in/ahmed-ayman-b64a50261",
  gmail: "ahmadaymansayed@gmail.com",
  display: true 
};

// Skills Section
const skillsSection = {
  title: "What I do",
  subTitle: "FULL-STACK SOFTWARE ENGINEER | SPRING BOOT + REACT + AI/ML",
  skills: [
    emoji(
      "⚡ Design and develop scalable full-stack web applications using Spring Boot and React"
    ),
    emoji("⚡ Build production-grade RESTful APIs with clean architecture, JWT security, and high performance"),
    emoji(
      "⚡ Integrate Machine Learning models (YOLOv8, Gradient Boosting, Transformers) and BI solutions into real-world systems"
    ),
    emoji("⚡ Deliver end-to-end solutions from requirements analysis to deployment with SOLID principles and CI/CD")
  ],
  softwareSkills: [
    {
      skillName: "java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "spring-boot",
      fontAwesomeClassname: "fas fa-leaf" // Spring Boot icon (leaf is commonly used)
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "git",
      fontAwesomeClassname: "fab fa-git-alt"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws" 
    },
    {
      skillName: "tensorflow",
      fontAwesomeClassname: "fas fa-brain"
    },
    {
      skillName: "yolo",
      fontAwesomeClassname: "fas fa-video" 
    }
  ],
  display: true 
};

// Education Section
const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Cairo University",
      logo: require("./assets/images/cairo-university-logo.png"),
      subHeader: "B.S. in Computers and Artificial Intelligence",
      duration: "2020 – 2024 | Giza, Egypt",
      desc: "Related Coursework: OOP, Web-based, Information Retrieval, Software Engineering, Database Systems, Operating Systems, Forecasting and Predictive Analytics, Computer Networks, Data Structures, Algorithms.",
      descBullets: [
        "Graduation Project: Optimization of the Tourism Industry (10/2023 - 07/2024)",
        "Designed complete optimization system with custom mathematical model and relational database (ERD)",
        "Built ML-based demand prediction using Gradient Boosting Regressor",
        "Developed desktop GUI application using C# .NET Framework (Windows Forms / WPF)",
        "Technologies: C#, .NET Framework, Python, SQL, Machine Learning, ERD, Excel"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience
const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Backend / Spring Boot", 
      progressPercentage: "90%"
    },
    {
      Stack: "Frontend / React",
      progressPercentage: "85%"
    },
    {
      Stack: "AI/ML & Computer Vision",
      progressPercentage: "80%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section
const workExperiences = {
  display: true,
  experience: [
    {
      role: "Software Engineer",
      company: "Huawei",
      companylogo: require("./assets/images/huawei-logo.png"),
      date: "Nov 2024 – Sep 2025",
      desc: "Designed and delivered production-grade RESTful APIs using Spring Boot for large-scale telecom operators and enterprise clients.",
      descBullets: [
        "Optimized SQL queries and database schemas, resulting in 20% faster data retrieval in live production systems.",
        "Collaborated in agile cross-functional teams to deliver complete end-to-end features with clean architecture, automated testing, and CI/CD pipelines.",
        "Presented technical demos to internal stakeholders and translated complex logic into clear business value."
      ]
    },
    {
      role: "Software Product Manager",
      company: "Huawei",
      companylogo: require("./assets/images/huawei-logo.png"),
      date: "Oct 2025 – Present",
      desc: "Led end-to-end product management for multiple telecom and digital solutions (AICC, RBT, Mobile Money) serving carriers and enterprise customers.",
      descBullets: [
        "Acted as the primary bridge between business stakeholders, technical teams, and C-level executives.",
        "Translated market and customer requirements into detailed product specifications, business use cases, and technical documents.",
        "Conducted strategic presentations and alignment meetings with government entities and senior decision-makers.",
        "Ensured product alignment with business objectives and validated system requirements throughout the development lifecycle."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */
const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on
const bigProjects = {
  title: "Projects",
  subtitle: "NOTABLE FULL-STACK, AI/ML & OPTIMIZATION PROJECTS",
  projects: [
    {
      image: require("./assets/images/ecommerce.png"),   
      projectName: "e-Commerce Backend System",
      projectDesc: "Scalable e-commerce backend with RESTful APIs, JWT authentication, Spring Security, and layered architecture.",
      footerLink: [
      { 
        name: "Project Details", 
        url: "https://github.com/ahmadayman28/" 
      }
      ]
    },
    {
      image: require("./assets/images/employee.png"),   
      projectName: "Employee Management System",
      projectDesc: "Production-grade full-stack system using Spring Boot 3 + React.js with pagination, advanced search, and clean architecture.",
      footerLink: [
      { 
        name: "Project Details", 
        url: "https://github.com/ahmadayman28/Employee-Management-System" 
      }
      ]
    },
    {
    image: require("./assets/images/accident.png"),   
    projectName: "Accident Detection with Alerting System",
    projectDesc: "Real-time road accident detection using YOLOv8 + automated SMS/email alerts + admin dashboard on Huawei Cloud.",
    footerLink: [
      { 
        name: "Project Details", 
        url: "https://github.com/Magdyyx/Accident-Detection-With-Alerting-System" 
      }
      ]
    },
    {
      image: require("./assets/images/cpu.png"),    
      projectName: "CPU Scheduler Simulator ",
      projectDesc: "Developed a Java-based simulation tool for various CPU scheduling algorithms, including First Come First Serve, Shortest Job First, Priority, and Round Robin",
      footerLink: [{ name: "Project Details", url: "https://github.com/ahmadayman28/CPU-Scheduler-Simulator" }]
    }
  ],
  display: true
};

const achievementSection = {
  title: emoji("Achievements And Awards 🏆 "),
  subtitle:
    "Competitions, Global Prizes, and Recognitions",
  achievementsCards: [
    {
      title: "2nd Place – Huawei Developer Cloud Competition Northern Africa Spark Infinity",
      subtitle:
        "Developed Intelligent Traffic Management System (Traffic Eye) using Huawei Technologies to enhance road safety and reduce accident response time.",
      image: require("./assets/images/huawei-logo.png"),
      imageAlt: "Huawei Spark Infinity",
      footerLink: []
    },
    {
      title: "First Prize Globally – Huawei AI Innovation Competition (Shenzhen, China)",
      subtitle:
        "Developed Automated Accident Detection System with alerting module and admin dashboard. Secured 1st place nationally, regionally, and globally against 80+ countries.",
      image: require("./assets/images/huawei-logo.png"),
      imageAlt: "Huawei AI Competition",
      footerLink: []
    },
    {
      title: "Finalist – AIC-1 NLP Competition",
      subtitle:
        "Top 15 out of 355 teams. Finetuned AraBART transformer model for Abstractive Arabic Summarization.",
      image: require("./assets/images/military-technical-college.png"),
      imageAlt: "AIC-1",
      footerLink: []
    },
    {
      title: "Meta Hacker Cup 2022",
      subtitle:
        "Passed qualification round out of 27,000 competitors and advanced to Round 1.",
      image: require("./assets/images/meta-logo.png"),
      imageAlt: "Meta Hacker Cup",
      footerLink: []
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs, Talks, Podcast sections are disabled because they are not present in your CV
const blogSection = {
  display: false
};
const talkSection = {
  display: false
};
const podcastSection = {
  display: false
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+201095027860",
  email_address: "ahmadaymansayed@gmail.com"
};

const twitterDetails = { userName: "", display: false };
const isHireable = false; // You are currently at Huawei – set to true only if actively looking for new opportunities

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  isHireable,
  twitterDetails,
  resumeSection
};